import { ACTION_PREVIEW_STYLE_CONFIG } from '@frontend/components/src/components/aiElements/actionPreview/actionPreviewStyleConfig';
import { CONVERSATION_STYLE_CONFIG } from '@frontend/components/src/components/aiElements/conversation/conversationStyleConfig';
import { MESSAGE_GROUP_STYLE_CONFIG } from '@frontend/components/src/components/aiElements/messageGroup/messageGroupStyleConfig';
import { PROMPTBAR_STYLE_CONFIG } from '@frontend/components/src/components/aiElements/promptBar/promptBarStyleConfig';
import { THINKING_STYLE_CONFIG } from '@frontend/components/src/components/aiElements/thinking/thinkingStyleConfig';
import { CONTAINER_STYLE_CONFIG } from '@frontend/components/src/components/appElements/container/containerStyleConfig';
import { FILE_INLINE_CARD_STYLE_CONFIG } from '@frontend/components/src/components/appElements/fileInlineCard/fileInlineCardStyleConfig';
import { PART_STYLE_CONFIG } from '@frontend/components/src/components/appElements/part/partStyleConfig';
import { BADGE_STYLE_CONFIG } from '@frontend/components/src/components/dataDisplay/badge/badgeStyleConfig';
import { DIVIDER_STYLE_CONFIG } from '@frontend/components/src/components/dataDisplay/divider/dividerStyleConfig';
import { PERCENTAGE_BREAKDOWN_STYLE_CONFIG } from '@frontend/components/src/components/dataDisplay/percentageBreakdown/percentageBreakdownStyleConfig';
import { STAT_STYLE_CONFIG } from '@frontend/components/src/components/dataDisplay/stat/statStyleConfig';
import { TABLE_STYLE_CONFIG } from '@frontend/components/src/components/dataDisplay/table/tableStyleConfig';
import { TAG_STYLE_CONFIG } from '@frontend/components/src/components/dataDisplay/tag/tagStyleConfig';
import { ACCORDION_STYLE_CONFIG } from '@frontend/components/src/components/disclosure/accordion/accordionStyleConfig';
import { SEGMENT_CONTROL_STYLE_CONFIG } from '@frontend/components/src/components/disclosure/segmentControl/segmentControlStyleConfig';
import { TABS_STYLE_CONFIG } from '@frontend/components/src/components/disclosure/tabs/tabsStyleConfig';
import { ALERT_STYLE_CONFIG } from '@frontend/components/src/components/feedback/alert/alertStyleConfig';
import { EMPTY_STYLE_CONFIG } from '@frontend/components/src/components/feedback/empty/emptyStyleConfig';
import { PROGRESS_STYLE_CONFIG } from '@frontend/components/src/components/feedback/progress/progressStyleConfig';
import { SKELETON_STYLE_CONFIG } from '@frontend/components/src/components/feedback/skeleton/skeletonStyleConfig';
import { SPINNER_STYLE_CONFIG } from '@frontend/components/src/components/feedback/spinner/spinnerStyleConfig';
import { TOAST_STYLE_CONFIG } from '@frontend/components/src/components/feedback/toast/toastStyleConfig';
import { BUTTON_STYLE_CONFIG } from '@frontend/components/src/components/forms/button/buttonStyleConfig';
import { CASCADER_STYLE_CONFIG } from '@frontend/components/src/components/forms/cascader/cascaderStyleConfig';
import { CHECKBOX_STYLE_CONFIG } from '@frontend/components/src/components/forms/checkbox/checkboxStyleConfig';
import { CLOSE_BUTTON_STYLE_CONFIG } from '@frontend/components/src/components/forms/closeButton/closeButtonStyleConfig';
import { FORM_STYLE_CONFIG } from '@frontend/components/src/components/forms/form/formStyleConfig';
import { FORM_ERROR_STYLE_CONFIG } from '@frontend/components/src/components/forms/formError/formErrorStyleConfig';
import { FORM_LABEL_STYLE_CONFIG } from '@frontend/components/src/components/forms/formLabel/formLabelStyleConfig';
import { ICON_BUTTON_STYLE_CONFIG } from '@frontend/components/src/components/forms/iconButton/iconButtonStyleConfig';
import { INPUT_STYLE_CONFIG } from '@frontend/components/src/components/forms/input/inputStyleConfig';
import { NUMBER_INPUT_STYLE_CONFIG } from '@frontend/components/src/components/forms/numberInput/numberInputStyleConfig';
import { PIN_INPUT_STYLE_CONFIG } from '@frontend/components/src/components/forms/pinInput/pinInputStyleConfig';
import { RADIO_STYLE_CONFIG } from '@frontend/components/src/components/forms/radio/radioStyleConfig';
import { SEARCH_INPUT_STYLE_CONFIG } from '@frontend/components/src/components/forms/searchInput/searchInputStyleConfig';
import { SELECT_STYLE_CONFIG } from '@frontend/components/src/components/forms/select/selectStyleConfig';
import { SLIDER_STYLE_CONFIG } from '@frontend/components/src/components/forms/slider/sliderStyleConfig';
import { SWITCH_STYLE_CONFIG } from '@frontend/components/src/components/forms/switch/switchStyleConfig';
import { TEXTAREA_STYLE_CONFIG } from '@frontend/components/src/components/forms/textarea/textareaStyleConfig';
import { AVATAR_STYLE_CONFIG } from '@frontend/components/src/components/mediaAndIcons/avatar/avatarStyleConfig';
import { BREADCRUMB_STYLE_CONFIG } from '@frontend/components/src/components/navigation/breadcrumb/breadcrumbStyleConfig';
import { DRAG_SUMMARY_STYLE_CONFIG } from '@frontend/components/src/components/overlay/dragSummary/dragSummaryStyleConfig';
import { DRAWER_STYLE_CONFIG } from '@frontend/components/src/components/overlay/drawer/drawerStyleConfig';
import { MENU_STYLE_CONFIG } from '@frontend/components/src/components/overlay/menu/menuStyleConfig';
import { MODAL_STYLE_CONFIG } from '@frontend/components/src/components/overlay/modal/modalStyleConfig';
import { POPOVER_STYLE_CONFIG } from '@frontend/components/src/components/overlay/popover/popoverStyleConfig';
import { TOOLTIP_STYLE_CONFIG } from '@frontend/components/src/components/overlay/tooltip/tooltipStyleConfig';
import { HEADING_STYLE_CONFIG } from '@frontend/components/src/components/typography/heading/headingStyleConfig';
import { MARK_STYLE_CONFIG } from '@frontend/components/src/components/typography/highlight/markStyleConfig';
import { TEXT_STYLE_CONFIG } from '@frontend/components/src/components/typography/text/textStyleConfig';

export const components = {
  // App elements
  Part: PART_STYLE_CONFIG,
  Container: CONTAINER_STYLE_CONFIG,
  FileInlineCard: FILE_INLINE_CARD_STYLE_CONFIG,

  // AI elements
  ActionPreview: ACTION_PREVIEW_STYLE_CONFIG,
  PromptBar: PROMPTBAR_STYLE_CONFIG,
  Conversation: CONVERSATION_STYLE_CONFIG,
  MessageGroup: MESSAGE_GROUP_STYLE_CONFIG,
  Thinking: THINKING_STYLE_CONFIG,

  // Data display
  Badge: BADGE_STYLE_CONFIG,
  Divider: DIVIDER_STYLE_CONFIG,
  PercentageBreakdown: PERCENTAGE_BREAKDOWN_STYLE_CONFIG,
  Stat: STAT_STYLE_CONFIG,
  Table: TABLE_STYLE_CONFIG,
  Tag: TAG_STYLE_CONFIG,
  // Disclosure
  Accordion: ACCORDION_STYLE_CONFIG,
  SegmentControl: SEGMENT_CONTROL_STYLE_CONFIG,
  Tabs: TABS_STYLE_CONFIG,
  // Feedback
  Alert: ALERT_STYLE_CONFIG,
  Empty: EMPTY_STYLE_CONFIG,
  Progress: PROGRESS_STYLE_CONFIG,
  Skeleton: SKELETON_STYLE_CONFIG,
  Spinner: SPINNER_STYLE_CONFIG,
  Toast: TOAST_STYLE_CONFIG,
  // Forms
  Button: BUTTON_STYLE_CONFIG,
  Checkbox: CHECKBOX_STYLE_CONFIG,
  CloseButton: CLOSE_BUTTON_STYLE_CONFIG,
  Cascader: CASCADER_STYLE_CONFIG,
  Form: FORM_STYLE_CONFIG,
  FormError: FORM_ERROR_STYLE_CONFIG,
  FormLabel: FORM_LABEL_STYLE_CONFIG,
  IconButton: ICON_BUTTON_STYLE_CONFIG,
  Input: INPUT_STYLE_CONFIG,
  NumberInput: NUMBER_INPUT_STYLE_CONFIG,
  PinInput: PIN_INPUT_STYLE_CONFIG,
  Radio: RADIO_STYLE_CONFIG,
  SearchInput: SEARCH_INPUT_STYLE_CONFIG,
  Select: SELECT_STYLE_CONFIG,
  Slider: SLIDER_STYLE_CONFIG,
  Switch: SWITCH_STYLE_CONFIG,
  Textarea: TEXTAREA_STYLE_CONFIG,
  // Highlight
  Mark: MARK_STYLE_CONFIG,
  // Media and Icons
  Avatar: AVATAR_STYLE_CONFIG,
  // Navigation
  Breadcrumb: BREADCRUMB_STYLE_CONFIG,
  // Overlay
  DragSummary: DRAG_SUMMARY_STYLE_CONFIG,
  Drawer: DRAWER_STYLE_CONFIG,
  Menu: MENU_STYLE_CONFIG,
  Modal: MODAL_STYLE_CONFIG,
  Popover: POPOVER_STYLE_CONFIG,
  Tooltip: TOOLTIP_STYLE_CONFIG,
  // Typography
  Heading: HEADING_STYLE_CONFIG,
  Text: TEXT_STYLE_CONFIG,
} as const;
